import { useCallback, useState } from 'react'
import { fetchApiWithToken } from '~/api/utils'
import { ToastType } from '~/components/Global/Interactions/Toast/ToastType'
import { dismissToast, toast } from '~/utils'

export const useCollectionExport = ({
  resourceKey,
  filename
}: {
  resourceKey: string
  filename: string
}): {
  exportCollection: (params: URLSearchParams) => Promise<void>
  isExporting: boolean
} => {
  const [isExporting, setIsExporting] = useState(false)

  const exportCollection = useCallback(
    async (params: URLSearchParams) => {
      setIsExporting(true)
      const progressToastId = toast(
        'Export en cours',
        'Génération du fichier en cours…',
        ToastType.Default,
        300_000
      )
      try {
        const query = params.toString()
        const url = query
          ? `/v1/exports/${resourceKey}?${query}`
          : `/v1/exports/${resourceKey}`

        const { blob, filename: responseFilename } = await fetchApiWithToken<{
          blob: Blob
          filename: string | null
        }>({
          method: 'get',
          url,
          responseType: 'blobWithDisposition'
        })

        const objectUrl = URL.createObjectURL(blob)
        const anchor = document.createElement('a')
        anchor.href = objectUrl
        anchor.download = responseFilename ?? filename
        anchor.click()
        URL.revokeObjectURL(objectUrl)
      } catch {
        toast(
          'Export impossible',
          "Une erreur est survenue lors de l'export.",
          ToastType.Danger
        )
      } finally {
        if (progressToastId) {
          dismissToast(progressToastId)
        }
        setIsExporting(false)
      }
    },
    [resourceKey, filename]
  )

  return { exportCollection, isExporting }
}
